import $firebase from "firebase/compat/app";
import { apiUser } from "@/components/toLoad/api";
import { listUtils } from "@/components/toLoad/listUtils";

import _moment from "moment";

const findWithAttr = function(array, attr, value) {
  for (let i = 0; i < array.length; i += 1)
    if (array[i][attr] === value)
      return i;

  return -1;
};

export const functions = {
  getInitials: function(name, max = 3) {
    if (!name) return "";
    return String(name)
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, max)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  },
  /**
   * Return the link with the good size of image input
   * @param {String} path
   * @param {Number} size
   * @returns {String}
   */
  getImgLink: function(path, size = "800x800") {
    if (path && typeof path === "object" && typeof path.link === "string")
      path = path.link;
    if (!path || typeof path !== "string") return "";

    const sizeStr = typeof size === "number" ? `_${size}x${size}` : `_${size}`;
    const qIndex = path.indexOf("?");
    const basePath = qIndex === -1 ? path : path.slice(0, qIndex);
    const query = qIndex === -1 ? "" : path.slice(qIndex);
    const sizedWebp = /_\d+x\d+\.webp$/i;

    if (sizedWebp.test(basePath))
      return basePath.replace(sizedWebp, `${sizeStr}.webp`) + query;

    const fileName = decodeURIComponent(basePath.split("/").pop() || "");
    const extMatch = /\.([a-zA-Z0-9]+)$/.exec(fileName);
    if (!extMatch || !/^(jpe?g|png|gif|webp)$/i.test(extMatch[1])) return path;

    const extIndex = basePath.lastIndexOf(`.${extMatch[1]}`);
    if (extIndex === -1) return path;
    return `${basePath.slice(0, extIndex)}${sizeStr}.webp${query}`;
  },
  /**
   * Remove all iterations of a given image
   * @param {String} path
   */
  removeImgFromStorage: function(path) {
    const sizes = listUtils.imgSizes;

    for (const size of sizes)
      $firebase
        .app()
        .storage(process.env.VUE_APP_FIREBASE_STORAGE_BUCKET)
        .ref(`${path}_${size}x${size}`)
        .delete();
  },
  /**
   * Returns a string from a provided date and format
   * @param {Date} date
   * @param {String} format
   * @returns {String}
   */
  getDateFormat(date, format = "DD/MM/YYYY à HH:mm") {
    if (!date) return "";
    const value = typeof date.toDate === "function" ? date.toDate() : date;
    return _moment(value).format(format);
  },
  /**
   * Returns if a user can access a module
   * @param {String} user
   * @param {String} module
   * @returns {Boolean}
   */
  hasModule: async function(user, module) {
    const { data } = await apiUser({ url: `/companies/${user.company}` });
    return (data.modules || []).some((item) => item.id === module);
  },
  /**
   * Open a new tab with the provided link
   * @param {String} link
   * @param {String} param
   */
  goTo: function(link, param = "_blank") {
    window.open(link, param);
  },

  /**
   * Returns the position of a item with a specific attribute in an array
   * @param {Array} array
   * @param {String} attr
   * @param {String} value
   * @returns {Number}
   */
  findWithAttr,

  /**
   * Gets the next index of a provided array
   * @param {Array} array
   * @param {Number} n
   * @returns {Number}
   */
  getNextIndex: function(array, n) {
    if (!array?.length) return 1;

    const numbers = array
      .map((item) => Number(item[n]))
      .filter((value) => !Number.isNaN(value));

    if (!numbers.length) return 1;

    const max = Math.max(...numbers);
    return max > 0 ? max + 1 : 1;
  },

  uniqueReference: function(existing = []) {
    const used = new Set((existing || []).filter(Boolean));
    let reference = "";
    do
      reference = Math.random().toString(36).substring(2, 8).toUpperCase();
    while (used.has(reference));
    return reference;
  },

  /**
   * Returns a hexadecimal from a provided string
   * @param {String} str
   * @returns {String<Hexa>}
   */
  convertToHex: function(str) {
    let result = "";
    if (!str) return;
    for (let i = 0; i < 3; i++)
      result += str.codePointAt(i).toString(16);

    return result;
  },

  /**
   * Gets a number within 0 and provided size
   * @param {Number} size
   * @returns {Number}
   */
  randomNumbers: function(size) {
    let result = "";
    for (let i = 0; i < size; i++)
      result += String(Math.floor(Math.random() * 10));

    return result;
  },

  truncateString(str, max, suffix = "...") {
    return str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(" "))}${suffix}`;
  },
};
